export default {
  mock: {
    config: {},
    headers: {},
    status: 400,
    statusText: '',
    data: {
      errors: [
        {
          code: 'E4401',
          message: 'HTTP認証が失敗しました'
        }
      ]
    }
  }
}